<!-- eslint-disable prettier/prettier -->
<template>
  <v-container v-if="planDataIsRetrieved">
    <v-tabs grow>
      <v-tab>Rapporter</v-tab>
      <v-tab-item class="mt-3">
        <v-tabs grow>
          <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_evaluering }}</v-tab>
          <v-tab>{{ GET_ORDLYD && GET_ORDLYD.main_obli_activities }}</v-tab>
          <v-tab>{{ GET_ORDLYD && GET_ORDLYD.main_ovrige_activities }}</v-tab>
          <v-tab ripple>{{
            GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities
          }}</v-tab>

          <v-tab-item> <!-- Evaluering -->
            <v-data-table
              :items="rapportevaluering"
              :expand="true"
              hide-actions
              :headers="rapportevalueringheaders"
            >
              <template v-slot:items="props">
                <tr :class="{ 'blue lighten-3': props.expanded }">
                  <td :class="{ 'display-1': props.expanded }">
                    {{ props.item.question }}
                  </td>
                  <td>{{ props.item.notanswered }}</td>
                  <td>{{ props.item.yes }}</td>
                  <td>{{ props.item.no }}</td>
                  <td>
                    <v-btn icon @click="props.expanded = !props.expanded">
                      <v-icon v-if="props.expanded">remove</v-icon>
                      <v-icon v-else>add</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card class="pl-3" color="blue lighten-3">
                  <!-- <v-container grid-list-md> -->
                  <!-- <v-layout align-start justify-space-between row fill-height wrap> -->
                  <template v-for="(sector, sectorindex) in plan.sectors.filter( (el) => el.label !== 'Å Avdelinger ikke lenger i bruk')">
                    <v-flex
                      xs12
                      v-for="(area, areaindex) in plan.areas.filter(
                        (el) => el.sector_id == sector.id
                      )"
                      :key="area.id"
                    >
                      <v-card
                        :class="{ 'mt-3': areaindex > 0 || sectorindex > 0 }"
                        flat
                      >
                        <v-card-title class="title"
                          >{{ sector.label }} - {{ area.label }}</v-card-title
                        >
                        <v-card-text>
                          <v-data-table
                            hide-actions
                            :items="
                              props.item.answers.filter(
                                (el) =>
                                  el.sector_label == sector.label &&
                                  el.area_label == area.label
                              )
                            "
                            :headers="rapportevalueringdetaljerheaders"
                          >
                            <template v-slot:items="props">
                              <tr
                                :class="{
                                  'green lighten-2': props.item.completed == 1,
                                  'red darken-1 grey--text text--lighten-3':
                                    props.item.completed == 2,
                                }"
                              >
                                <td>{{ props.item.avd_label }}</td>
                                <td width="200">
                                  {{ props.item.completed_label }}
                                </td>
                              </tr>
                              <tr v-if="props.item.text">
                                <td
                                  colspan="2"
                                  class="blue lighten-3 black--text font-weight-light font-italic pl-5"
                                >
                                  "{{ props.item.text }}"
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                  <!-- </v-layout> -->
                  <!-- </v-container> -->
                </v-card>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item> <!-- Obligatoriske aktiviteter-->
            <v-data-table
              :items="rapportoblaktiviteter"
              :expand="true"
              :headers="rapportoblaktiviteterheaders"
              hide-actions
            >
              <template v-slot:items="props">
                <tr
                  :class="{
                    'blue lighten-3': props.expanded,
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <td width="15%">{{ props.item.category }}</td>
                  <td width="40%">{{ props.item.measure }}</td>
                  <td width="20%">{{ props.item.responsibility }}</td>
                  <td width="20%">
                    {{ props.item.done }} / {{ props.item.totalanswers }}
                  </td>
                  <td>
                    <v-btn icon @click="props.expanded = !props.expanded">
                      <v-icon v-if="props.expanded">remove</v-icon>
                      <v-icon v-else>add</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card
                  class="pl-3"
                  color="blue lighten-3"
                  :class="{
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <template v-for="(sector, sectorindex) in plan.sectors.filter((el) => el.label !== 'Å Avdelinger ikke lenger i bruk')">
                    <v-flex
                      xs12
                      v-for="(area, areaindex) in plan.areas.filter(
                        (el) => el.sector_id == sector.id
                      )"
                      :key="area.id"
                    >
                      <v-card
                        :class="{ 'mt-3': areaindex > 0 || sectorindex > 0 }"
                        flat
                      >
                        <v-card-title class="title"
                          >{{ sector.label }} - {{ area.label }}</v-card-title
                        >
                        <v-card-text>
                          <v-data-table
                            hide-actions
                            :items="
                              props.item.answers.filter(
                                (el) =>
                                  el.sector_label == sector.label &&
                                  el.area_label == area.label
                              )
                            "
                            :headers="rapportoblaktiviteterdetaljerheaders"
                          >
                            <template v-slot:items="props">
                              <tr>
                                <td width="33%">{{ props.item.avd_label }}</td>
                                <td width="33%">
                                  {{ props.item.schedule || "Ikke besvart" }}
                                </td>
                                <td>
                                  {{
                                    (props.item.done &&
                                      props.item.doneDate &&
                                      props.item.doneDate.slice(0, 10)) ||
                                      "Ikke utført"
                                  }}
                                </td>
                              </tr>
                              <tr v-if="props.item.text">
                                <td colspan="3" class="font-weight-bold pa-5">
                                  {{ props.item.text }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                </v-card>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item> <!-- Øvrige aktiviteter -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="rapportOvrigeAktiviteter"
              :headers="rapportHeaders"
              :search="search"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                  <tr class="activities">
                    <td>{{ props.item.avd_label }}</td>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.brukAv }}</td>
                    <td>{{ props.item.responsibility }}</td>
                    <td>{{ props.item.doneDate }}</td>
                  </tr>
              </template>
            </v-data-table>
            <vue-excel-xlsx
                :data="rapportOvrigeAktiviteter"
                :columns="excelHeaders"
                :file-name="'filename'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                >
                <v-btn>
                  Eksporter
                </v-btn>
              </vue-excel-xlsx>
          </v-tab-item>
          <v-tab-item> <!-- BRUK AV BHT OG ALS -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="rapportBrukAvHmsOgAlsAktiviteter"
              :headers="rapportHeaders"
              :search="search"
              :must_sort="avdeling"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                  <tr class="activities">
                    <td>{{ props.item.avd_label }}</td>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.brukAv }}</td>
                    <td>{{ props.item.responsibility }}</td>
                    <td>{{ props.item.doneDate }}</td>
                  </tr>
                </template>
              </v-data-table>
              <vue-excel-xlsx
                :data="rapportBrukAvHmsOgAlsAktiviteter"
                :columns="excelHeaders"
                :file-name="'filename'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                class="btn"
                >
                <v-btn>
                  Eksporter
                </v-btn>
              </vue-excel-xlsx>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
    </v-tabs>
   
  </v-container>
  <v-layout v-else fill-height column align-center justify-center>
    <v-alert :value="true" type="info">
      Vennligst vent mens vi henter data..
      <v-progress-linear
        indeterminate
        color="primary"
        class="mb-0"
      ></v-progress-linear>
    </v-alert>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Doc from "./components/Doc.js";
import Title from "./components/Title.js";
import {
  Placeholder,
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  methods: {
    ...mapActions(["GET_REPORT", "FETCH_ORDLYD"]),


    getPlan() {
      this.loadingDialogText = "Vennligst vent mens vi henter data";
      this.loadingDialog = true;

      this.GET_REPORT(this.$route.params.guid)
        .then((res) => {
          this.loadingDialog = false;
          this.plan = res.data;
          //console.log('plan:', this.plan)
          this.plan.activities.forEach((element) => {
            element.kategori_meny = false;
          });
          this.planDataIsRetrieved = true;
          // this.planEditors.planTitle.setContent(this.plan.planning[0]["title"]);
          this.planTitle = this.plan.planning["title"];
          this.planEditors.planDescription.setContent(
            this.plan.planning["description"]
          );
          this.planEditors.planOverordnaMaal.setContent(
            this.plan.planning["overordna_maalsetting"]
          );
          this.planEditors.planAvdMaal.setContent(
            this.plan.planning["avd_maalsetting"]
          );
          this.planEditors.planVeiledning.setContent(
            this.plan.planning["veiledning"]
          );
          this.registeredchanges = false;
          this.rapportoblaktiviteter = this.setrapportoblaktiviteter();
          //this.rapportovrigeaktiviteter = this.setrapportovrigeaktiviteter();
          //this.rapportbrukavhmsogalsaktiviteter = this.setrapportbrukavhmsogalsaktiviteter();
          this.rapportevaluering = this.setrapportevaluering();
          this.rapportOvrigeAktiviteter = this.setRapportOvrigeAktiviteter();
          this.rapportBrukAvHmsOgAlsAktiviteter = this.setRapportBrukAvHmsOgAlsAktiviteter();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    setRapportBrukAvHmsOgAlsAktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.bruk_av_hms_og_als_activities
        .filter((activity) => activity.planningid == this.plan.planning.id && activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
        .forEach((el) => {
          _thisRapportOverview.push(el);
        });
      return _thisRapportOverview;
    },

    setRapportOvrigeAktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.ovrige_activities
        .filter((activity) => activity.planningid == this.plan.planning.id && activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
        .forEach((el) => {
          _thisRapportOverview.push(el)
        });
        return _thisRapportOverview
    },

    setrapportevaluering() {
      let _thisRapportOverview = [];
      this.plan.reports.evaluation
      .filter((evaluation) => evaluation.sector_label !== "Å Avdelinger ikke lenger i bruk")
      .forEach((el) => {
        //console.log(el)
        if (
          _thisRapportOverview.filter((ro) => ro.id == el.evaluation_id)
            .length == 0
        ) {
          _thisRapportOverview.push({
            id: el.evaluation_id,
            question: el.evaluation_question,
            notanswered: 0,
            yes: 0,
            no: 0,
          });
        }
      });
      _thisRapportOverview.forEach((ro) => {
        ro.answers = this.plan.reports.evaluation
          .filter((el) => el.evaluation_id == ro.id && el.sector_label !== "Å Avdelinger ikke lenger i bruk")
          .map((el) => {
            return {
              avd_label: el.avd_label,
              sector_label: el.sector_label,
              area_label: el.area_label,
              text: el.text,
              completed: el.completed,
              completed_label:
                el.completed == 2
                  ? "Nei"
                  : el.completed == 1
                  ? "Ja"
                  : "Ikke besvart",
            };
          });

        ro.notanswered = ro.answers.filter((el) => !el.completed).length;
        ro.yes = ro.answers.filter((el) => el.completed == 1).length;
        ro.no = ro.answers.filter((el) => el.completed == 2).length;
      });
      return _thisRapportOverview;
    },
    setrapportoblaktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.obl_activities
      .filter((activity) => activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
      .forEach((el) => {
        if (
          _thisRapportOverview.filter((ro) => ro.id == el.mainid).length == 0
        ) {
          _thisRapportOverview.push({
            id: el.mainid,
            schedule: el.mainschedule,
            measure: el.mainmeasure,
            category: el.maincategory,
            responsibility: el.mainresponsibility,
            done: 0,
          });
        }
      });
      _thisRapportOverview.forEach((ro) => {
        ro.answers = this.plan.reports.obl_activities
          .filter((el) => el.mainid == ro.id && el.sector_label !== "Å Avdelinger ikke lenger i bruk")
          .map((el) => {
            return {
              avd_label: el.avd_label,
              sector_label: el.sector_label,
              area_label: el.area_label,
              schedule: el.schedule,
              done: el.done,
              doneDate: el.doneDate,
            };
          });

        ro.done = ro.answers.filter((el) => !!el.doneDate).length;
        ro.totalanswers = ro.answers.length;
      });
      let _thisCategories = [];
      _thisRapportOverview.forEach((el) => {
        if (
          _thisCategories.filter(
            (_thisCategory) => _thisCategory.label == el.category
          ).length == 0
        ) {
          _thisCategories.push({
            label: el.category,
            active: true,
            sort: _thisCategories.length + 1,
          });
        }
      });
      this.rapportoblaktiviteter_categories = _thisCategories;
      return _thisRapportOverview;
    },
  },
  data() {
    return {
      search: '', //Enables searching on data-tables
      pagination: {
        rowsPerPage: 25
      },

      maanedsvalg: [
        "Månedlig",
        "Jevnlig",
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      loadingDialog: false,
      loadingDialogText: "",
      registeredchanges: false,
      planDataIsRetrieved: false,
      plan: {},
      planTitle: "",
      planDescription: "",
      planOverordnaMaal: "",
      planAvdMaal: "",
      planVeiledning: "",
      newEvaluation: "",
      newSchedule: "",
      newMeasure: "",
      newResponsibility: "",
      newCategoryOverordnaAktivitet: "",
      newCategoryOverordnaAktivitetMeny: "",
      newCategoryObligatoriskAktivitetMeny: "",
      newCategoryObligatoriskAktivitet: "",
      newCategoryAvdAktivitet: "",
      newCategoryAvdAktivitetMeny: "",
      planEditors: {
        planDescription: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planOverordnaMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planAvdMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planVeiledning: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
      },
      rapportevalueringheaders: [
        { text: "Spørsmål", value: "question" },
        { text: "Ikke besvart", value: "notanswered" },
        { text: "Ja", value: "yes" },
        { text: "Nei", value: "no" },
        { text: "Se/skjul detaljer", value: "", sortable: false },
      ],
      rapportevalueringdetaljerheaders: [
        { text: "Avdeling", value: "avd_label" },
        { text: "Utført", value: "completed_label" },
      ],
      rapportoblaktiviteterheaders: [
        { text: "Kategori", value: "category" },
        { text: "Tiltak", value: "measure" },
        { text: "Ansvarlig", value: "responsibility" },
        { text: "Utført/Totalt", value: "" },
        { text: "Se/skjul detaljer", value: "", sortable: false },
      ],
      rapportoblaktiviteterdetaljerheaders: [
        { text: "Avdeling", value: "avd_label" },
        { text: "Tidsplan", value: "schedule" },
        { text: "Utført", value: "doneDate" },
      // eslint-disable-next-line prettier/prettier
      ],
      rapportovrigeheaders: [
        { text: "Tidsplan", value: "schedule" },
        { text: "Kategori", value: "category" },
        { text: "Tiltak", value: "measure" },
        { text: "Ansvarlig", value: "responsibility" },
        { text: "Utført", value: "completed_label" },
      ],
      sektorHeaders: [
        {text: "Sektor", value: "label"},
        {text: "Antall aktiviteter", value: "areaActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "areaActivities.done"}
      ],
      områdeHeaders: [
        {text: "Område", value: "label"},
        {text: "Antall aktiviteter", value: "orgActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "orgActivities.done"}
      ],
      avdelingHeaders: [
        {text: "Avdeling", value: "label"},
        {text: "Antall aktiviteter", value: "numActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "numActivities.done"}
      ],
      rapportHeaders: [
        {text: "Avdeling", value: "avd_label"},
        {text: "Tidsplan", value: "schedule"},
        {text: "Kategori", value: "category"},
        {text: "Tiltak", value: "measure"},
        {text: "Bruk av", value: "brukAv"},
        {text: "Ansvarlig", value: "responsibility"},
        {text: "Utført", value: "doneDate"}
      ],
      excelHeaders: [
        {label: "Avdeling", field: "avd_label"},
        {label: "Tidsplan", field: "schedule"},
        {label: "Kategori", field: "category"},
        {label: "Tiltak", field: "measure"},
        {label: "Bruk av", field: "brukAv"},
        {label: "Ansvarlig", field: "responsibility"},
        {label: "Utført", field: "doneDate"}
      ],

      rapportevaluering: [],
      rapportoblaktiviteter_categories: [],
      rapportoblaktiviteter: [],
      rapportovrigeaktiviteter_categories: [],
      rapportOvrigeAktiviteter: [],
      //rapportovrigeaktiviteter: [],
      rapportbrukavhmsogalsaktiviteter_categories: [],
      //rapportbrukavhmsogalsaktiviteter: [],
      rapportBrukAvHmsOgAlsAktiviteter: [],
      // rapportTesting: [],
    };
  },
  computed: {
    ...mapGetters(["GET_USER", "GET_ORDLYD"]),
    overordna_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "kommune");
    },
    avd_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "avdeling");
    },
    computedOvrigeActivities() {
    let total = this.rapportovrigeaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.total;
    }, 0);
    let done = this.rapportovrigeaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.done;
    }, 0);
    
    return `Totalt: ${total} Gjennomførte: ${done}`;
  },
  computedStotteActivities() {
    let total = this.rapportbrukavhmsogalsaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.total;
    }, 0);
    let done = this.rapportbrukavhmsogalsaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.done;
    }, 0);
    
    return `Totalt: ${total} Gjennomførte: ${done}`;
  },
  },
  mounted() {
    this.getPlan();
  },
  beforeDestroy() {
    this.planEditors.planDescription.destroy();
    this.planEditors.planOverordnaMaal.destroy();
    this.planEditors.planAvdMaal.destroy();
    this.planEditors.planVeiledning.destroy();
  },
  beforeRouteLeave(to, from, next) {
    if (this.registeredchanges) {
      const answer = window.confirm(
        "Er du sikker på at du ønsker å forlate siden? Du har endringer som ikke er lagret."
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

};
</script>

<style>

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 2rem;
  background-color: transparent;
}

#thead tr th {
  background-color: #f5f5f5;
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.activities {

}

.activities:nth-child(odd) {
    background-color: #cccccc;
  }

.ProseMirror {
  background-color: rgba(0, 0, 0, 0.06);
  padding: 20px 10px;
}
.is-hidden {
  visibility: hidden;
}
.is-hidden.is-focused {
  visibility: visible;
}
</style>
